/***************************************
 * Permissions-related error messages. *
 **************************************/

import { SUPPORT_EMAIL_ADDRESS } from './HPSEmailAddresses';

// A user made an API request for which they do not have the proper role.
export const API_FORBIDDEN_RESPONSE_MESSAGE = 'Unauthorized request.';
// A user tried to mount a component for which they do not have the proper role.
export const UNAUTHORIZED_MESSAGE = 'You are not authorized to view this page.';

/************************************
 * Feature-specific error messages. *
 ***********************************/
export const COMPLIANCE_REQUIREMENTS_NO_ACTIVITY = 'No compliance requirements to display. Map a requirement to a control to get started.';

/*************************
 * Other error messages. *
 ************************/
export const CONTACT_INFORMATION_FOR_ERROR_MESSAGE = `If this problem persists, please contact High Peaks Solutions at ${SUPPORT_EMAIL_ADDRESS}.`;
// Something unexpected happened.
export const GENERIC_ERROR_MESSAGE = `Something went wrong. ${CONTACT_INFORMATION_FOR_ERROR_MESSAGE}`;
// The WAF blocked a request.
export const WAF_BLOCK_MESSAGE = `Request blocked. ${CONTACT_INFORMATION_FOR_ERROR_MESSAGE}`;
